<template>
  <div class="NowShowingSlider">
    <div class="row py-2 menu-tab">
      <div class="col-3 text-center px-1" @click="bottomTab('1')">
        <svg
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 512 512"
          style="enable-background:new 0 0 512 512;width:25px"
          :fill="selectedBottomTab.indexOf('1') >= 0 ? '#E70D01' : '#777'"
          xml:space="preserve"
        >
          <g>
            <g>
              <path
                d="M506.555,208.064L263.859,30.367c-4.68-3.426-11.038-3.426-15.716,0L5.445,208.064
			c-5.928,4.341-7.216,12.665-2.875,18.593s12.666,7.214,18.593,2.875L256,57.588l234.837,171.943c2.368,1.735,5.12,2.57,7.848,2.57
			c4.096,0,8.138-1.885,10.744-5.445C513.771,220.729,512.483,212.405,506.555,208.064z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M442.246,232.543c-7.346,0-13.303,5.956-13.303,13.303v211.749H322.521V342.009c0-36.68-29.842-66.52-66.52-66.52
			s-66.52,29.842-66.52,66.52v115.587H83.058V245.847c0-7.347-5.957-13.303-13.303-13.303s-13.303,5.956-13.303,13.303v225.053
			c0,7.347,5.957,13.303,13.303,13.303h133.029c6.996,0,12.721-5.405,13.251-12.267c0.032-0.311,0.052-0.651,0.052-1.036v-128.89
			c0-22.009,17.905-39.914,39.914-39.914s39.914,17.906,39.914,39.914v128.89c0,0.383,0.02,0.717,0.052,1.024
			c0.524,6.867,6.251,12.279,13.251,12.279h133.029c7.347,0,13.303-5.956,13.303-13.303V245.847
			C455.549,238.499,449.593,232.543,442.246,232.543z"
              />
            </g>
          </g>
        </svg>
        <!-- <img src="@/assets/img/icons/transaction.png" width="30" height="30" /> -->
        <div
          class="menu-text"
          :class="selectedBottomTab.indexOf('1') >= 0 ? 'active' : ''"
        >
          Movies
        </div>
      </div>
      <div class="col-3 text-center px-1" @click="bottomTab('5')">
        <svg
          height="20pt"
          viewBox="0 -66 512 512"
          width="20pt"
          xmlns="http://www.w3.org/2000/svg"
          :fill="selectedBottomTab.indexOf('5') >= 0 ? '#E70D01' : '#777'"
        >
          <path
            d="m69.785156 20c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-.019531c-5.523437 0-9.992187 4.476562-9.992187 10s4.488281 10 10.011718 10zm0 0"
          />
          <path
            d="m502 284c5.523438 0 10-4.476562 10-10v-264c0-5.523438-4.476562-10-10-10h-392c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10h382v244h-44.960938c-4.5-18.34375-21.074218-32-40.789062-32h-57.5c-12.808594 0-24.289062 5.769531-32 14.839844-7.710938-9.070313-19.191406-14.839844-32-14.839844h-57.5c-12.808594 0-24.289062 5.769531-32 14.839844-7.710938-9.070313-19.191406-14.839844-32-14.839844h-57.5c-19.714844 0-36.289062 13.652344-40.789062 32h-44.960938v-244h21.035156c5.519532 0 10-4.476562 10-10s-4.480468-10-10-10h-31.035156c-5.523438 0-10 4.476562-10 10v264c0 5.523438 4.476562 10 10 10h53.75v12h-15.75c-23.15625 0-42 18.839844-42 42v32c0 5.523438 4.480469 10 10 10h386c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-11.5v-22c0-12.128906 9.871094-22 22-22h57.5c12.132812 0 22 9.867188 22 22v22h-21.035156c-5.519532 0-10 4.476562-10 10s4.480468 10 10 10h31.035156c5.523438 0 10-4.476562 10-10v-32c0-23.160156-18.839844-42-42-42h-21.75v-12zm-274.75-32h57.5c12.132812 0 22 9.871094 22 22v22h-15.75c-12.808594 0-24.289062 5.769531-32 14.839844-7.710938-9.070313-19.191406-14.839844-32-14.839844h-21.75v-22c0-12.128906 9.867188-22 22-22zm-143.5 22c0-12.128906 9.867188-22 22-22h57.5c12.128906 0 22 9.871094 22 22v22h-15.75c-12.808594 0-24.289062 5.769531-32 14.839844-7.710938-9.070313-19.191406-14.839844-32-14.839844h-21.75zm-57.75 86v-22c0-12.128906 9.871094-22 22-22h57.5c12.132812 0 22 9.867188 22 22v22zm121.5 0v-22c0-12.128906 9.871094-22 22-22h57.5c12.132812 0 22 9.867188 22 22v22zm121.5 0v-22c0-12.128906 9.871094-22 22-22h57.5c12.132812 0 22 9.867188 22 22v22zm143.5-64c-12.808594 0-24.289062 5.769531-32 14.839844-7.710938-9.070313-19.191406-14.839844-32-14.839844h-21.75v-22c0-12.128906 9.871094-22 22-22h57.5c12.132812 0 22 9.871094 22 22v22zm0 0"
          />
          <path
            d="m442.214844 360c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10h.019531c5.523437 0 9.992187-4.476562 9.992187-10s-4.488281-10-10.011718-10zm0 0"
          />
          <path
            d="m210.078125 202.378906c3.125 1.808594 6.554687 2.710938 9.984375 2.710938 3.417969 0 6.832031-.898438 9.949219-2.691406l91.984375-53.105469c6.144531-3.550781 9.957031-10.183594 9.953125-17.308594-.007813-7.207031-3.742188-13.664063-9.988281-17.261719-15.21875-8.785156-30.4375-17.578125-45.65625-26.371094-15.132813-8.742187-30.265626-17.484374-45.402344-26.222656-6.078125-3.933594-13.792969-4.265625-20.238282-.847656-6.546874 3.476562-10.613281 10.238281-10.613281 17.652344l.042969 106.164062c-.007812 7.199219 3.726562 13.660156 9.984375 17.28125zm9.988281-123.441406c.1875.128906.382813.25.582032.363281 15.21875 8.789063 30.4375 17.578125 45.652343 26.371094 15.1875 8.773437 30.371094 17.542969 45.613281 26.347656l-91.820312 53.011719-.039062-106.089844c.003906 0 .007812-.003906.011718-.003906zm0 0"
          />
        </svg>
        <!-- <img src="@/assets/img/icons/profiles.png" width="30" height="30" /> -->
        <div
          class="menu-text"
          :class="selectedBottomTab.indexOf('5') >= 0 ? 'active' : ''"
        >
          Cinema
        </div>
      </div>
      <!-- <div class="col-3 text-center px-1" @click="bottomTab('2')">
        <svg
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 512.003 512.003"
          style="enable-background:new 0 0 512.003 512.003;width:25px"
          :fill="selectedBottomTab.indexOf('2')>=0?'#E70D01':'#777'"
          xml:space="preserve"
        >
          <g>
            <g>
              <path
                d="M477.958,262.633c-2.06-4.215-2.06-9.049,0-13.263l19.096-39.065c10.632-21.751,2.208-47.676-19.178-59.023l-38.41-20.38
			c-4.144-2.198-6.985-6.11-7.796-10.729l-7.512-42.829c-4.183-23.846-26.241-39.87-50.208-36.479l-43.053,6.09
			c-4.647,0.656-9.242-0.838-12.613-4.099l-31.251-30.232c-17.401-16.834-44.661-16.835-62.061,0L193.72,42.859
			c-3.372,3.262-7.967,4.753-12.613,4.099l-43.053-6.09c-23.975-3.393-46.025,12.633-50.208,36.479l-7.512,42.827
			c-0.811,4.62-3.652,8.531-7.795,10.73l-38.41,20.38c-21.386,11.346-29.81,37.273-19.178,59.024l19.095,39.064
			c2.06,4.215,2.06,9.049,0,13.263l-19.096,39.064c-10.632,21.751-2.208,47.676,19.178,59.023l38.41,20.38
			c4.144,2.198,6.985,6.11,7.796,10.729l7.512,42.829c3.808,21.708,22.422,36.932,43.815,36.93c2.107,0,4.245-0.148,6.394-0.452
			l43.053-6.09c4.643-0.659,9.241,0.838,12.613,4.099l31.251,30.232c8.702,8.418,19.864,12.626,31.03,12.625
			c11.163-0.001,22.332-4.209,31.03-12.625l31.252-30.232c3.372-3.261,7.968-4.751,12.613-4.099l43.053,6.09
			c23.978,3.392,46.025-12.633,50.208-36.479l7.513-42.827c0.811-4.62,3.652-8.531,7.795-10.73l38.41-20.38
			c21.386-11.346,29.81-37.273,19.178-59.024L477.958,262.633z M464.035,334.635l-38.41,20.38
			c-12.246,6.499-20.645,18.057-23.04,31.713l-7.512,42.828c-1.415,8.068-8.874,13.487-16.987,12.342l-43.053-6.09
			c-13.73-1.945-27.316,2.474-37.281,12.113L266.5,478.152c-5.886,5.694-15.109,5.694-20.997,0l-31.251-30.232
			c-8.422-8.147-19.432-12.562-30.926-12.562c-2.106,0-4.229,0.148-6.355,0.449l-43.053,6.09
			c-8.106,1.146-15.571-4.274-16.987-12.342l-7.513-42.829c-2.396-13.656-10.794-25.215-23.041-31.712l-38.41-20.38
			c-7.236-3.839-10.086-12.61-6.489-19.969l19.096-39.065c6.088-12.456,6.088-26.742,0-39.198l-19.096-39.065
			c-3.597-7.359-0.747-16.13,6.489-19.969l38.41-20.38c12.246-6.499,20.645-18.057,23.04-31.713l7.512-42.828
			c1.416-8.068,8.874-13.488,16.987-12.342l43.053,6.09c13.725,1.943,27.316-2.474,37.281-12.113l31.252-30.232
			c5.886-5.694,15.109-5.694,20.997,0l31.251,30.232c9.965,9.64,23.554,14.056,37.281,12.113l43.053-6.09
			c8.107-1.147,15.572,4.274,16.987,12.342l7.512,42.829c2.396,13.656,10.794,25.215,23.041,31.712l38.41,20.38
			c7.236,3.839,10.086,12.61,6.489,19.969l-19.096,39.064c-6.088,12.455-6.088,26.743,0,39.198l19.096,39.064
			C474.121,322.024,471.271,330.796,464.035,334.635z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M363.886,148.116c-5.765-5.766-15.115-5.766-20.881,0L148.116,343.006c-5.766,5.766-5.766,15.115,0,20.881
			c2.883,2.883,6.662,4.325,10.44,4.325c3.778,0,7.558-1.441,10.44-4.325l194.889-194.889
			C369.653,163.231,369.653,153.883,363.886,148.116z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M196.941,123.116c-29.852,0-54.139,24.287-54.139,54.139s24.287,54.139,54.139,54.139s54.139-24.287,54.139-54.139
			S226.793,123.116,196.941,123.116z M196.941,201.863c-13.569,0-24.608-11.039-24.608-24.609c0-13.569,11.039-24.608,24.608-24.608
			c13.569,0,24.609,11.039,24.609,24.608C221.549,190.824,210.51,201.863,196.941,201.863z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M315.061,280.61c-29.852,0-54.139,24.287-54.139,54.139s24.287,54.139,54.139,54.139
			c29.852,0,54.139-24.287,54.139-54.139S344.913,280.61,315.061,280.61z M315.061,359.357c-13.569,0-24.609-11.039-24.609-24.608
			s11.039-24.608,24.609-24.608c13.569,0,24.608,11.039,24.608,24.608S328.63,359.357,315.061,359.357z"
              />
            </g>
          </g>
        </svg>

        <div class="menu-text" :class="selectedBottomTab.indexOf('2')>=0?'active':''">Special offers</div>
      </div>-->
      <div class="col-3 text-center px-1" @click="bottomTab('3')">
        <!-- <img src="@/assets/img/icons/transaction.png" width="30" height="30" /> -->

        <svg
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 349.158 349.158"
          style="enable-background:new 0 0 349.158 349.158;width:25px"
          xml:space="preserve"
          :fill="selectedBottomTab.indexOf('3') >= 0 ? '#E70D01' : '#777'"
        >
          <g>
            <g>
              <path
                d="M341.658,6.227H83.455c-4.143,0-7.5,3.357-7.5,7.5V162.83H7.5c-4.143,0-7.5,3.357-7.5,7.5v127.123
			c0,25.076,20.4,45.479,45.477,45.479c0.646,0,258.203,0,258.203,0c25.076,0,45.479-20.402,45.479-45.479V13.727
			C349.158,9.584,345.801,6.227,341.658,6.227z M15,297.453V177.83h60.955v119.623c0,16.805-13.672,30.479-30.479,30.479
			C28.672,327.932,15,314.258,15,297.453z M334.158,297.453c0,16.805-13.672,30.479-30.479,30.479H79.203
			c7.299-8.07,11.752-18.766,11.752-30.479V21.227h243.203V297.453z"
              />
              <path
                d="M202.023,92.855h96.127c4.143,0,7.5-3.357,7.5-7.5c0-4.143-3.357-7.5-7.5-7.5h-96.127c-4.143,0-7.5,3.357-7.5,7.5
			C194.523,89.498,197.881,92.855,202.023,92.855z"
              />
              <path
                d="M202.023,175.248h96.127c4.143,0,7.5-3.357,7.5-7.5c0-4.143-3.357-7.5-7.5-7.5h-96.127c-4.143,0-7.5,3.357-7.5,7.5
			C194.523,171.891,197.881,175.248,202.023,175.248z"
              />
              <path
                d="M202.023,257.643h96.127c4.143,0,7.5-3.357,7.5-7.5c0-4.143-3.357-7.5-7.5-7.5h-96.127c-4.143,0-7.5,3.357-7.5,7.5
			C194.523,254.285,197.881,257.643,202.023,257.643z"
              />
              <path
                d="M132.814,101.295c1.418,1.5,3.391,2.35,5.453,2.35c0.02,0,0.041,0,0.063,0c2.086-0.018,4.07-0.902,5.477-2.443
			l41.197-45.121c2.793-3.059,2.576-7.803-0.482-10.596c-3.059-2.791-7.803-2.576-10.596,0.482l-35.752,39.156l-11.129-11.785
			c-2.846-3.012-7.594-3.146-10.604-0.303c-3.012,2.844-3.146,7.59-0.303,10.602L132.814,101.295z"
              />
              <path
                d="M173.926,131.941l-35.752,39.154l-11.131-11.783c-2.844-3.014-7.592-3.148-10.602-0.303
			c-3.012,2.844-3.146,7.59-0.303,10.602l16.676,17.656c1.418,1.5,3.391,2.35,5.453,2.35c0.02,0,0.041,0,0.063,0
			c2.086-0.018,4.07-0.902,5.477-2.443l41.197-45.119c2.791-3.059,2.576-7.803-0.482-10.596S176.719,128.881,173.926,131.941z"
              />
              <path
                d="M173.926,217.914l-35.752,39.154l-11.131-11.783c-2.844-3.014-7.592-3.149-10.602-0.303
			c-3.012,2.844-3.146,7.59-0.303,10.602l16.676,17.656c1.418,1.5,3.391,2.35,5.453,2.35c0.02,0,0.041,0,0.063,0
			c2.086-0.018,4.07-0.902,5.477-2.443l41.197-45.119c2.791-3.059,2.576-7.803-0.482-10.596
			C181.463,214.639,176.719,214.855,173.926,217.914z"
              />
            </g>
          </g>
        </svg>

        <div
          class="menu-text"
          :class="selectedBottomTab.indexOf('3') >= 0 ? 'active' : ''"
        >
          My transaction
        </div>
      </div>
      <div class="col-3 text-center px-1" @click="bottomTab('4')">
        <svg
          height="25"
          viewBox="0 0 480 480"
          width="30"
          xmlns="http://www.w3.org/2000/svg"
          style="enable-background:new 0 0 512.003 512.003;"
          :fill="selectedBottomTab.indexOf('4') >= 0 ? '#E70D01' : '#777'"
        >
          <path
            d="m240 0c-132.546875 0-240 107.453125-240 240s107.453125 240 240 240c7.230469 0 14.433594-.324219 21.601562-.96875 6.664063-.597656 13.269532-1.511719 19.824219-2.65625l2.519531-.445312c121.863282-22.742188 206.359376-134.550782 194.960938-257.996094-11.398438-123.445313-114.9375-217.8945315-238.90625-217.933594zm-19.28125 463.152344h-.566406c-6.222656-.550782-12.398438-1.382813-18.519532-2.449219-.351562-.0625-.703124-.101563-1.046874-.167969-5.984376-1.070312-11.90625-2.398437-17.769532-3.949218l-1.417968-.363282c-5.71875-1.550781-11.375-3.351562-16.949219-5.351562-.578125-.207032-1.160157-.390625-1.738281-.605469-5.464844-2.007813-10.832032-4.257813-16.117188-6.691406-.65625-.292969-1.3125-.574219-1.96875-.886719-5.183594-2.398438-10.265625-5.101562-15.25-7.945312-.703125-.398438-1.414062-.796876-2.117188-1.191407-4.90625-2.863281-9.699218-5.933593-14.402343-9.175781-.710938-.496094-1.429688-.976562-2.136719-1.472656-4.621094-3.277344-9.125-6.757813-13.511719-10.398438l-1.207031-1.054687v-67.449219c.058594-48.578125 39.421875-87.941406 88-88h112c48.578125.058594 87.941406 39.421875 88 88v67.457031l-1.0625.886719c-4.472656 3.734375-9.0625 7.265625-13.777344 10.601562-.625.4375-1.257812.855469-1.878906 1.285157-4.757812 3.304687-9.632812 6.414062-14.625 9.335937-.625.363282-1.265625.707032-1.886719 1.066406-5.058593 2.878907-10.203125 5.597657-15.449219 8.046876-.601562.28125-1.207031.542968-1.816406.800781-5.328125 2.457031-10.742187 4.71875-16.246094 6.742187-.546874.203125-1.097656.378906-1.601562.570313-5.601562 2.007812-11.28125 3.824219-17.03125 5.382812l-1.378906.34375c-5.871094 1.550781-11.796875 2.886719-17.789063 3.960938-.34375.0625-.6875.105469-1.03125.160156-6.128906 1.070313-12.3125 1.902344-18.539062 2.457031h-.566407c-6.398437.550782-12.800781.847656-19.28125.847656-6.480468 0-12.933593-.242187-19.320312-.792968zm179.28125-66.527344v-52.625c-.066406-57.410156-46.589844-103.933594-104-104h-112c-57.410156.066406-103.933594 46.589844-104 104v52.617188c-86.164062-87.941407-85.203125-228.9375 2.148438-315.699219 87.351562-86.757813 228.351562-86.757813 315.703124 0 87.351563 86.761719 88.3125 227.757812 2.148438 315.699219zm0 0"
          />
          <path
            d="m240 64c-44.183594 0-80 35.816406-80 80s35.816406 80 80 80 80-35.816406 80-80c-.046875-44.164062-35.835938-79.953125-80-80zm0 144c-35.347656 0-64-28.652344-64-64s28.652344-64 64-64 64 28.652344 64 64c-.039062 35.328125-28.671875 63.960938-64 64zm0 0"
          />
        </svg>
        <!-- <img src="@/assets/img/icons/profiles.png" width="30" height="30" /> -->
        <div
          class="menu-text"
          :class="selectedBottomTab.indexOf('4') >= 0 ? 'active' : ''"
        >
          My Profile
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Slick from "vue-slick";
import { makeRequest } from "@/helper/internet.js";
import $ from "jquery";
import EventBus from "@/eventBus.js";
import { TokenService, CountryService } from "@/services/storage.service";

export default {
  name: "NowShowingSlider",

  components: {
    Slick
  },
  data() {
    return {
      routeName: "",
      loadingNow: true,
      selectedBottomTab: ["1"]
    };
  },
  mounted() {
    EventBus.$on("BOTTOMTABCHANGE", val => {
      this.selectedBottomTab = [];
      this.selectedBottomTab.push(val);
    });
  },
  watch: {},
  computed: {},
  methods: {
    bottomTab(val) {
      this.selectedBottomTab = [];
      this.selectedBottomTab.push(val);

      if (val == "1") {
        this.$router.push({
          path: "/"
        });
      } else if (val == "2") {
        this.$router.push({
          path: "/offers-promotions"
        });
      } else if (val == "5") {
        this.$router.push({
          path: "/cinema-page"
        });
      } else if (val == "3") {
        if (!localStorage.getItem("user")) {
          EventBus.$emit("SHOWSIGNIN");
        } else {
          this.$router.push({
            path: "/profile/myTransaction"
          });
        }
      } else if (val == "4") {
        if (!localStorage.getItem("user")) {
          EventBus.$emit("SHOWSIGNIN");
        } else {
          this.$router.push({
            path: "/profile/myaccount"
          });
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/partials/BottomBar.vue